import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Select } from 'antd'
import * as req from '../../common/requests'

import css from '../../common/Form.css'

const { Option } = Select

function delay(t) {
  return new Promise(resolve => {
    setTimeout(resolve, t)
  })
}

export default class OrthoTracSync extends Component {
  static propTypes = {
    carestreamCustomers: PropTypes.arrayOf(PropTypes.object),
    clearError: PropTypes.func.isRequired,
    getAndSaveLocationList: PropTypes.func.isRequired,
    practiceId: PropTypes.string.isRequired,
    onError: PropTypes.func.isRequired,
  }

  static defaultProps = {
    carestreamCustomers: [],
  }

  state = {
    customerId: undefined,
    error: false,
    loading: true,
    remoteDb: null,
  }

  componentWillMount() {
    const { practiceId } = this.props
    req
      .getRemoteDatabases(practiceId)
      .then(res => {
        if (res.length) {
          const db = res[0]
          this.setState({
            customerId: db.address,
            remoteDb: db,
            loading: false,
          })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch(() => {
        this.setState({ loading: false, error: true })
      })
  }

  saveCustomerId = e => {
    e.preventDefault()
    this.props.clearError()
    this.setState({ loading: true })

    const remoteDbRequestPromise = this.createOrUpdateRemoteDb()
    let remoteDb
    remoteDbRequestPromise
      .then(res => {
        if (res) {
          remoteDb = res
          this.setState({
            customerId: remoteDb.address,
            remoteDb: remoteDb,
          })
        }
      })
      .then(() => {
        req.scheduleSync(remoteDb.id)
      })
      .then(() => {
        delay(600).then(() => this.queryLocations(0))
      })
      .catch(err => {
        this.setState({
          loading: false,
        })
        this.props.setStepStatus(this.props.step, 'error')
        this.props.onError(err)
      })
  }

  queryLocations = count => {
    const { getAndSaveLocationList } = this.props
    return getAndSaveLocationList()
      .then(res => {
        if (res.length > 0) {
          this.setState({ loading: false })
          return Promise.resolve(res)
        } else if (count < 5) {
          return delay(600).then(() => this.queryLocations(count + 1))
        }
        this.setState({ loading: false })
        return Promise.reject(
          new Error(
            'Could not get locations. Check the sync was successful, the locations have valid addresses, and the Customer Id is correct.',
          ),
        )
      })
      .catch(err => {
        this.setState({
          loading: false,
        })
        this.props.setStepStatus(this.props.step, 'error')
        this.props.onError(err)
      })
  }

  createOrUpdateRemoteDb = () => {
    const { remoteDb, customerId } = this.state
    const { practiceId } = this.props
    const dbParams = {
      practice_id: practiceId,
      address: customerId,
    }
    return this.state.remoteDb
      ? req.updateRemoteDatabase(practiceId, remoteDb.id, dbParams)
      : req.createRemoteDatabase(practiceId, dbParams)
  }

  changeCustomerId = value => {
    this.setState({ customerId: value })
  }

  render() {
    const { customerId, error, loading, remoteDb } = this.state
    const saveSuccess = remoteDb && remoteDb.address === customerId
    let buttonText = 'CREATE'
    if (saveSuccess) {
      buttonText = 'SAVED'
    } else if (remoteDb && remoteDb.address !== customerId) {
      buttonText = 'UPDATE'
    } else {
      buttonText = 'CREATE'
    }
    // const buttonText = saveSuccess ? 'SAVED' : 'CREATE'
    // TODO: add a dropdown of all our Carestream clients.
    const customerOptions = this.props.carestreamCustomers.map(customer => (
      <Option key={customer.id} value={customer.id}>
        {`${customer.name} - ${customer.id}`}
      </Option>
    ))

    const filterOption = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

    return (
      <div className={css.customerSelect}>
        {error ? (
          <div> There was an error accessing the backend </div>
        ) : (
          <Form onSubmit={this.saveCustomerId}>
            <h3>OrthoTrac V2 Sync</h3>
            <Form.Item label="Customer ID from Carestream">
              <Select
                showSearch
                placeholder="Select a customer"
                onChange={this.changeCustomerId}
                filterOption={filterOption}
                value={customerId}
              >
                {customerOptions}
              </Select>
            </Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              disabled={!customerId}
              type={saveSuccess ? null : 'primary'}
              className={saveSuccess ? css.successButton : null}
            >
              {buttonText}
            </Button>
          </Form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/OrthoTracV2Sync.js